// Aturan tampil tombol purchasing — MURNI, diuji jest (aksiPurchasing.test.js).
// UI bukan keamanan: setiap aksi tetap dijaga backend. Fungsi ini hanya supaya layar tidak menawarkan tombol yang
// pasti ditolak, dan tidak menyembunyikan tombol yang sebenarnya boleh.

const STATUS_AKHIR_PO = ["CANCELLED", "CLOSED", "COMPLETED"];

// PO sudah dikirim ke vendor = vendor sudah ditetapkan (keluar dari PENDING_VENDOR). Cermin
// backend po_service.vendor_sudah_ditetapkan.
export function vendorSudahDitetapkan(po) {
  if (!po) return false;
  return Boolean(po.vendor_id) || (po.status || "PENDING_VENDOR") !== "PENDING_VENDOR";
}

// K203 / VONIS-27SEP-BUSINESS-56-65 (BUSINESS-57): tombol batal PO.
//  - PO menunggu vendor: "Batalkan PO" langsung untuk yang berhak (perm.cancel).
//  - PO sudah dikirim ke vendor: Owner batal langsung (perm.batal_langsung_terbit); Admin Purchasing
//    "Ajukan pembatalan" (perm.batal_ajukan) bila belum ada barang diterima dan belum ada pengajuan menunggu.
export function aksiBatalPO(po, perm, adaPengajuanMenunggu) {
  const p = perm || {};
  const hasil = { batalLangsung: false, ajukanBatal: false };
  if (!po || STATUS_AKHIR_PO.includes(po.status)) return hasil;
  const terkirim = vendorSudahDitetapkan(po);
  hasil.batalLangsung = Boolean(p.cancel) && (!terkirim || Boolean(p.batal_langsung_terbit));
  const adaTerima = Number(po.receipts_summary?.active_receipts || 0) > 0;
  hasil.ajukanBatal = terkirim && Boolean(p.batal_ajukan) && !adaTerima && !adaPengajuanMenunggu
    && !hasil.batalLangsung;
  return hasil;
}

// U2-C9: tombol Setujui/Tolak PR. `pr.penyetuju` dikirim backend (pr_service.penyetuju_pr — sumber yang sama
// dengan pagar approve/reject). PR dari Admin Gudang → hanya Kepala Cabang (Owner ikut bila melewati batas).
export function bolehPutusPR(pr, roleCode, profileId) {
  if (!pr || pr.status !== "SUBMITTED") return false;
  if (!["OWNER", "KEPALA_CABANG"].includes(roleCode)) return false;
  if (pr.requested_by && pr.requested_by === profileId) return false;
  if (Array.isArray(pr.penyetuju)) return pr.penyetuju.includes(roleCode);
  return true; // backend lama tanpa `penyetuju`: pagar tetap di backend
}

// TAGIHAN-PEMASOK-BATAL-POTONGAN-HILANG-01 (14 Okt 2026): tagihan pemasok yang sudah dipotong uang muka, potongan
// retur, atau potongan uang lebih TIDAK bisa dibatalkan (backend TAGIHAN_ADA_POTONGAN + pagar database) — potongannya
// akan hilang. Penolakan tetap boleh: potongannya menempel dan ikut kembali saat diajukan ulang.
export function potonganTagihanPemasok(inv) {
  const uangMuka = Number(inv?.dp_applied_amount || 0);
  const retur = Number(inv?.potongan_retur_idr || 0);
  const uangLebih = Number(inv?.potongan_uang_lebih_idr || 0);
  return { uangMuka, retur, uangLebih, total: uangMuka + retur + uangLebih };
}

// TOLAK-TAGIHAN-FINANCE-STATUS-LONGGAR-01: tombol "Tolak" Finance ditawarkan di tahap eksekusi — tagihan sudah
// disetujui (UNPAID, atau PARTIAL_PAID karena potongan) dan BELUM ada transfer masuk. Di PENDING_APPROVAL yang memutus
// penyetuju (tombol "Tolak Pengajuan"); tagihan PAID sudah tertutup (backend INVOICE_SUDAH_LUNAS).
export function bolehTolakEksekusi(bolehMenurutMeta, inv) {
  if (!bolehMenurutMeta || !inv) return false;
  return ["UNPAID", "PARTIAL_PAID"].includes(inv.status) && Number(inv.paid_amount || 0) === 0;
}

export function alasanBatalTagihanTertahan(inv) {
  if (potonganTagihanPemasok(inv).total <= 0) return null;
  let jalan = "Kalau isi tagihan salah, minta Finance menolaknya, lalu perbaiki dan ajukan ulang";
  if (inv?.status === "REJECTED") jalan = "Kalau isi tagihan salah, perbaiki lalu ajukan ulang";
  if (inv?.status === "PENDING_APPROVAL") {
    jalan = "Kalau isi tagihan salah, ubah tagihan ini selagi masih menunggu persetujuan";
  }
  return "Tagihan ini sudah memuat potongan, jadi tidak bisa dibatalkan langsung — potongannya akan hilang. "
    + `${jalan}; potongannya tetap menempel di tagihan ini. Bila tagihan ini memang harus dibatalkan seluruhnya, `
    + "pakai tombol Ajukan Pembatalan: Kepala Cabang menyetujui dan potongannya dilepas ke asalnya.";
}

// K219 / BUSINESS-94 (Owner 17 Okt 2026, "A1. b."): tagihan berpotongan dibatalkan lewat PENGAJUAN — Admin Purchasing
// mengajukan, Kepala Cabang menyetujui (pemohon ≠ penyetuju), potongan dilepas ke asalnya. Wewenang dari /meta
// (`permissions.ajukan_pembatalan` / `putus_pembatalan` + `transitions[].from`); backend tetap penjaga utamanya.
export function pembatalanTagihan(inv, bolehAjukanMenurutMeta, bolehPutusMenurutMeta, profileId) {
  const riwayat = inv?.pembatalan || [];
  const menunggu = riwayat.find((p) => p.status === "MENUNGGU_PERSETUJUAN") || null;
  const berpotongan = potonganTagihanPemasok(inv).total > 0;
  const belumDibayar = Number(inv?.paid_amount || 0) === 0;
  return {
    riwayat,
    menunggu,
    bolehAjukan: Boolean(bolehAjukanMenurutMeta) && berpotongan && belumDibayar && !menunggu,
    bolehPutus: Boolean(bolehPutusMenurutMeta) && Boolean(menunggu) && menunggu.diajukan_oleh !== profileId,
  };
}
